module.exports = __webpack_public_path__ + "img/BOUTON_RAFRAICHIR_FOND_BLANC.d384c31a.svg";